<template>
  <div class="row blaPrologueContainer">
    <ProgressBar
      :max-position="maxPosition"
      :current-position="currentPosition"
      :show="false"
      :fixed-header="true"
    />
    <div class="col-10 offset-1 col-md-10 offset-md-1">
      <div class="row mt-5 mb-2">
        <div class="col-2 text-right">
          <img
            :src="require('@/assets/img/exclamation_mark_icon.png')"
            alt="exclamation_mark_icon"
            class="blaExlaminationIcon"
          />
        </div>
        <div class="col-10 blaPrologueTitle">
          Hallgasd végig a következő hangoskönyvet!
        </div>
      </div>
    </div>
    <div class="col-10 offset-1 col-md-8 offset-md-2">
      <div class="row text-center mt-4 mb-2 audio-player">
        <div
          v-if="
            audioBook !== null &&
            audioBook.picture !== null &&
            audioBook.picture.url !== null
          "
          class="col-12"
        >
          <img
            :src="audioBook.picture.url"
            alt="audiobook cover"
            class="audioBookCover"
          />
        </div>
        <div class="col-10 offset-1 audio__btn-wrap">
          <div
            v-if="showPrevButton"
            class="audio__play-prev"
            @click.stop="remove15sec"
            :style="{
              color: themeColor,
            }"
          >
            <slot name="play-prev">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6 audio__play-icon"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M18.75 19.5l-7.5-7.5 7.5-7.5m-6 15L5.25 12l7.5-7.5"
                />
              </svg>
            </slot>
          </div>
          <div v-if="isLoading" class="audio__play-loading">
            <span>
              <div class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </span>
          </div>

          <template v-else>
            <div
              v-if="!isPlaying && showPlayButton"
              class="audio__play-start"
              @click.stop="play"
            >
              <slot name="play-start">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6 audio__play-icon"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
                  />
                </svg>
              </slot>
            </div>

            <div
              v-else-if="showPlayButton"
              class="audio__play-pause"
              @click.stop="pause"
            >
              <slot name="play-pause">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6 audio__play-icon"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15.75 5.25v13.5m-7.5-13.5v13.5"
                  />
                </svg>
              </slot>
            </div>
          </template>
          <div
            v-if="showNextButton"
            class="audio__play-next"
            @click.stop="add15sec"
            :style="{
              color: themeColor,
            }"
          >
            <slot name="play-next">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6 audio__play-icon"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M11.25 4.5l7.5 7.5-7.5 7.5m-6-15l7.5 7.5-7.5 7.5"
                />
              </svg>
            </slot>
          </div>
        </div>
        <div class="col-10 offset-1">
          <div
            v-show="showProgressBar"
            ref="audioProgressWrap"
            class="audio__progress-wrap"
            @click.stop="handleClickProgressWrap"
          >
            <div
              ref="audioProgress"
              class="audio__progress"
              :style="{
                backgroundColor: themeColor,
              }"
            />
            <div
              ref="audioProgressPoint"
              class="audio__progress-point"
              :style="{
                backgroundColor: themeColor,
                boxShadow: `0 0 10px 0 ${themeColor}`,
              }"
              @panstart="handleProgressPanstart"
              @panend="handleProgressPanend"
              @panmove="handleProgressPanmove"
            />
          </div>

          <div v-show="showProgressBar" class="audio__time-wrap">
            <div class="audio__current-time">
              {{ currentTimeFormatted }}
            </div>
            <div class="audio__duration">
              {{ durationFormatted }}
            </div>
          </div>

          <audio
            v-if="
              audioBook !== null &&
              audioBook.audio !== null &&
              audioBook.audio.url !== null
            "
            ref="audio"
            class="audio-player__audio"
            :src="audioBook.audio.url"
            v-bind="$attrs"
            @ended="onEnded"
            @timeupdate="onTimeUpdate"
            @loadedmetadata="onLoadedmetadata"
          >
            Audio lejátszásanem lehetséges
          </audio>
        </div>
      </div>
    </div>
    <div class="col-10 offset-1 col-md-2 offset-md-5">
      <div class="blaPrologueNextButton p-3 clickable" @click="goToNext">
        Tovább
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Core from "@any-touch/core";
import Pan from "@any-touch/pan";
import ProgressBar from "@/components/partials/ProgressBar";
import Loader from "@/components/partials/Loader";
// import LazyYoutubeVideo from "vue-lazy-youtube-video";

export default {
  components: {
    ProgressBar,
    Loader,
    // LazyYoutubeVideo,
  },
  emits: [
    "pause",
    "play-prev",
    "play-next",
    "timeupdate",
    "loadedmetadata",
    "ended",
    "progress-start",
    "progress-end",
    "progress-move",
    "progress-click",
    "playing",
    "play",
    "play-error",
  ],
  data: () => ({
    lessonId: "",
    audioBook: null,
    apiUrl: "",
    maxPosition: 0,
    currentPosition: 0,

    //Player specific variables
    isIOS: /iPhone|iPad|iPod/i.test(window.navigator.userAgent),
    isPlaying: false,
    isDragging: false,
    isDraggingVolume: false,
    isShowErrorMessage: false,
    isLoading: false,
    isShowVolume: false,
    isShowRates: false,
    timer: null,
    noticeMessage: "",
    duration: "",
    currentPlayIndex: 0,
    currentTime: "",
    currentVolume: 1,
    playbackRate: 1,
    at: null,
    themeColor: "rgba(99, 61, 252, .8)",
    showProgressBar: true,
    showPlayButton: true,
    showNextButton: true,
    showPrevButton: true,
  }),
  methods: {
    getData() {
      axios
        .post(this.$store.getters.getApiUrl + "/api/lesson/audioBook/load", {
          token: this.$store.getters.getToken,
          lessonId: this.$data.lessonId,
        })
        .then((response) => {
          //Store the lesson data
          this.audioBook = response.data.audioBook;
          console.log(this.audioBook);
        })
        .catch((error) => {
          console.log("audioBook - error: ", error);
        });
    },
    goToNext() {
      //Pause audioBook
      this.pause();

      //Move to SelfValue
      this.$router.push({
        name: "selfValue",
        params: {
          lessonId: this.lessonId,
          fromAudioBook: 1,
        },
      });
    },
    handleSetPlaybackRate(rate) {
      this.playbackRate = +rate;
      this.$refs.audio.playbackRate = +rate;
      this.isShowRates = false;
    },
    handleShowErrorMessage(opts = {}) {
      this.noticeMessage = opts.message;
      this.isShowErrorMessage = true;
      window.setTimeout(() => {
        this.isShowErrorMessage = false;
      }, opts.duration || 3000);
    },
    onLoadedmetadata(event) {
      this.duration = this.$refs.audio.duration;
      this.$emit("loadedmetadata", event);
    },
    onTimeUpdate(event) {
      //   console.log("time update");
      this.$emit("timeupdate", event);
      //   console.log(this.currentTimeFormatted);
      //   console.log(this.$refs.audio.currentTime);
      //   this.currentTime = this.$refs.audio.currentTime;
    },
    formatTime(second) {
      let minutes;
      //   let hours;

      //   hours = Math.floor(second / 60 / 60);

      //   if (hours >= 1) {
      //     minutes = Math.floor(second / 60 - 60);
      //   } else {
      minutes = Math.floor(second / 60);
      //   }

      second = Math.ceil(second % 60);
      //   if (second >= 60) {
      //     second = second - 60;
      //   }

      //   hours += "";
      minutes += "";
      second += "";
      //   hours = hours.length === 1 ? "0" + hours : hours;
      minutes = minutes.length === 1 ? "0" + minutes : minutes;
      second = second.length === 1 ? "0" + second : second;
      //   return hours + ":" + minutes + ":" + second;
      return minutes + ":" + second;
    },
    onEnded(event) {
      window.setTimeout(() => {
        this.pause();
        this.$emit("ended", event);
        if (this.isLoop && this.isAutoPlayNext) {
          this.playNext();
        }
      }, 1000);
    },
    handleProgressPanstart(event) {
      if (this.disabledProgressDrag) return;
      this.isDragging = true;
      this.$emit("progress-start", event);
    },
    handleProgressPanend(event) {
      if (this.disabledProgressDrag) return;
      this.$refs.audio.currentTime = this.currentTime;
      this.play();
      this.isDragging = false;
      this.$emit("progress-end", event);
    },
    handleProgressPanmove(event) {
      if (this.disabledProgressDrag) return;
      let pageX = event.x;
      let bcr = event.target.getBoundingClientRect();
      let targetLeft = parseInt(getComputedStyle(event.target).left);
      let offsetLeft = targetLeft + (pageX - bcr.left);
      offsetLeft = Math.min(
        offsetLeft,
        this.$refs.audioProgressWrap.offsetWidth
      );
      offsetLeft = Math.max(offsetLeft, 0);
      this.setPointPosition(offsetLeft);
      this.$refs.audioProgress.style.width = offsetLeft + "px";
      this.currentTime =
        (offsetLeft / this.$refs.audioProgressWrap.offsetWidth) * this.duration;
      this.$emit("progress-move", event);
    },
    handleClickProgressWrap(event) {
      if (this.disabledProgressClick) return;
      let target = event.target;
      let offsetX = event.offsetX;
      if (target === this.$refs.audioProgressPoint) {
        return;
      }
      this.currentTime =
        (offsetX / this.$refs.audioProgressWrap.offsetWidth) * this.duration;
      this.$refs.audio.currentTime = this.currentTime;
      this.setPointPosition(offsetX);
      this.$refs.audioProgress.style.width = offsetX + "px";
      this.play();
      this.$emit("progress-click", event);
    },
    add15sec() {
      this.$refs.audio.currentTime = this.$refs.audio.currentTime + 15;
      this.currentTime = this.$refs.audio.currentTime;
    },
    remove15sec() {
      this.$refs.audio.currentTime = this.$refs.audio.currentTime - 15;
      this.currentTime = this.$refs.audio.currentTime;
    },
    setPointPosition(offsetLeft) {
      this.$refs.audioProgressPoint.style.left =
        offsetLeft - this.$refs.audioProgressPoint.offsetWidth / 2 + "px";
    },
    playing() {
      if (this.isDragging) {
        return;
      }
      let offsetLeft =
        (this.$refs.audio.currentTime / this.$refs.audio.duration) *
        this.$refs.audioProgressWrap.offsetWidth;
      this.currentTime = this.$refs.audio.currentTime;
      this.$refs.audioProgress.style.width = offsetLeft + "px";
      this.setPointPosition(offsetLeft);
      this.$emit("playing");
    },
    play() {
      this.isLoading = true;
      let handlePlay = () => {
        this.$refs.audio
          .play()
          .then(() => {
            this.$nextTick(() => {
              this.clearTimer();
              this.timer = window.setInterval(
                this.playing,
                this.progressInterval
              );
              this.isPlaying = true;
              this.isLoading = false;
            });
            this.$emit("play");
          })
          .catch((data) => {
            this.handleShowErrorMessage({
              message: data.message,
            });
            // Failed to load because no supported source was found.
            if (data.code === 9) {
              if (this.isAutoPlayNext) {
                window.setTimeout(() => {
                  this.playNext();
                }, 1000);
              }
            }
            this.isLoading = false;
            this.$emit("play-error", data);
          });
      };
      if (this.isIOS) {
        console.log("The play() request was interrupted by a call to pause()");
        this.$refs.audio.play();
        this.$refs.audio.pause();
      }
      if (this.beforePlay) {
        this.beforePlay((state) => {
          if (state !== false) {
            handlePlay();
          }
        });
        return;
      }
      handlePlay();
    },
    pause() {
      this.$refs.audio.pause();
      this.$nextTick(() => {
        this.clearTimer();
        this.isPlaying = false;
        this.$emit("pause");
      });
    },
    clearTimer() {
      window.clearInterval(this.timer);
      this.timer = null;
    },
  },
  mounted: function () {
    //Init required variables
    this.lessonId = this.$store.getters.currentLessonId;
    this.apiUrl = this.$store.getters.getApiUrl;

    //Get data
    this.getData();

    //Init touch
    this.at = new Core(this.$el, { preventDefault: false });
    this.at.use(Pan);
  },
  beforeUnmount() {
    this.pause();
    // this.$refs.audio.pause();
    this.at.destroy();
  },
  computed: {
    currentTimeFormatted() {
      return this.currentTime ? this.formatTime(this.currentTime) : "00:00";
    },
    durationFormatted() {
      return this.duration ? this.formatTime(this.duration) : "00:00";
    },
  },
};
</script>
<style>
@keyframes fadeVolume {
  from {
    height: 0;
  }
  to {
    height: 50px;
  }
}
@keyframes fadeRate {
  from {
    max-height: 0;
  }
  to {
    max-height: 120px;
  }
}
.fade-volume-enter-active {
  animation: fadeVolume 0.3s;
}
.fade-volume-leave-active {
  animation: fadeVolume 0.3s reverse;
}
.fade-rate-enter-active {
  animation: fadeRate 0.3s;
}
.fade-rate-leave-active {
  animation: fadeRate 0.3s reverse;
}
.audio-player .audio__btn-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.audio-player .audio__play-icon {
  width: 100%;
  height: 100%;
  fill: currentColor;
  overflow: hidden;
}
.audio-player .audio__play-volume-icon-wrap {
  position: relative;
  width: 21px;
  height: 21px;
  cursor: pointer;
  touch-action: none;
  user-select: none;
  -webkit-user-drag: none;
  margin-left: 16px;
}
.audio-player .audio__play-volume-icon-wrap .audio__play-volume-wrap {
  position: absolute;
  width: 21px;
  height: 50px;
  bottom: 21px;
  left: 0;
  background-color: #ddd;
  border-radius: 10px;
}
.audio-player
  .audio__play-volume-icon-wrap
  .audio__play-volume-wrap
  .audio__play-volume {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 10px;
}
.audio-player .audio__play-rate {
  position: relative;
  height: 21px;
  line-height: 21px;
  cursor: pointer;
  touch-action: none;
  user-select: none;
  -webkit-user-drag: none;
  font-size: 16px;
  margin-right: 16px;
}
.audio-player .audio__play-rate__dropdown {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding: 2px;
  color: #fff;
  border-radius: 15px;
  font-size: 12px;
  overflow: hidden;
}
.audio-player .audio__play-prev {
  cursor: pointer;
  touch-action: none;
  user-select: none;
  -webkit-user-drag: none;
}
.audio-player .audio__play-prev svg {
  display: flex;
  width: 42px;
  height: 42px;
  margin-top: 1.5rem;
}
.audio-player .audio__play-prev.disable {
  opacity: 0.5;
}
.audio-player .audio__play-start {
  margin: 2rem auto 0.5rem;
  cursor: pointer;
  touch-action: none;
  user-select: none;
  -webkit-user-drag: none;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  box-shadow: -1px 10px 20px -6px rgba(99, 61, 252, 0.8);
  background-color: rgb(99 61 252);
  color: white;
  align-items: center;
  justify-content: center;
  display: flex;
}
.audio-player .audio__play-start svg {
  width: 42px;
  height: 42px;
}
.audio-player .audio__play-pause {
  margin: 2rem auto 0.5rem auto;
  cursor: pointer;
  touch-action: none;
  user-select: none;
  -webkit-user-drag: none;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  box-shadow: -1px 10px 20px -6px rgba(99, 61, 252, 0.8);
  background-color: rgb(99 61 252);
  color: white;
  align-items: center;
  justify-content: center;
  display: flex;
}
.audio-player .audio__play-pause svg {
  width: 42px;
  height: 42px;
}
.audio-player .audio__play-next {
  cursor: pointer;
  touch-action: none;
  user-select: none;
  -webkit-user-drag: none;
}
.audio-player .audio__play-next svg {
  display: block;
  width: 42px;
  height: 42px;
  margin-top: 1.5rem;
}
.audio-player .audio__play-next.disable {
  opacity: 0.5;
}
.audio__notice {
  position: absolute;
  bottom: -15px;
  color: rgb(189, 178, 178);
  border-radius: 4px;
  font-size: 12px;
}
.audio-player .audio__progress-wrap {
  position: relative;
  background: #ddd;
  height: 4px;
  border-radius: 3px;
  margin-top: 20px;
  cursor: pointer;
  touch-action: none;
  user-select: none;
  -webkit-user-drag: none;
}
.audio-player .audio__progress {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 0;
  border-radius: 3px;
}
.audio-player .audio__progress-point {
  position: absolute;
  left: -8px;
  top: 50%;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-top: -8px;
}
.audio-player .audio__progress-point:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  margin: -4px 0 0 -4px;
  background: #fff;
  border-radius: 50%;
}
.audio-player .audio__time-wrap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 7px;
}
.audio-player .audio__current-time {
  font-size: 10px;
  color: #888;
}
.audio-player .audio__duration {
  font-size: 10px;
  color: #888;
}
.audio-player .audio-player__audio {
  display: block;
  margin: 0 auto;
}
@media (any-hover: hover) {
  .audio-player .audio__play-rate:hover > span {
    opacity: 0.7;
  }
  .audio-player .audio__play-rate__dropdown > div:hover,
  .audio__play-icon:hover {
    opacity: 0.7;
  }
}
.audio__play-loading {
  margin: 2rem auto 0.5rem;
  cursor: pointer;
  touch-action: none;
  user-select: none;
  -webkit-user-drag: none;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  box-shadow: -1px 10px 20px -6px rgba(99, 61, 252, 0.8);
  background-color: rgb(99 61 252);
  color: white;
  align-items: center;
  justify-content: center;
  display: flex;
}
.audio__play-loading span {
  display: flex;
  border-radius: 50%;
  align-items: center;
  align-self: center;
  justify-content: center;
}
.audio-player .audio__play-loading .lds-ring {
  width: 42px !important;
  height: 42px !important;
}
.audio-player .audio__play-loading .lds-ring div {
  width: 42px;
  height: 42px;
  border-color: #fff transparent transparent transparent;
  margin: 0;
}

.blaPrologueNextButton {
  margin-top: 2rem;
}
</style>
